import { HomeWrapper } from "./styles";

import { Footer } from "components/footer";
import { Founder } from "./components/Founder";
import { WelcomeScreen } from "./components/WelcomeScreen";

import { About } from "./components/About";
import { AlgorithmsSection } from "./components/AlgorithmsSection";
import ValidationSection from "./components/ValidationSection";
import WizardSteps from "./components/WizardSteps";
import { useHeaderContext } from "providers/HeaderProvider";

export default function Home() {
  const { setOpenRegister } = useHeaderContext();

  return (
    <HomeWrapper container position="relative" justifyContent="center">
      <WelcomeScreen {...{ setOpenRegister }} />
      <About />
      {/*<ProductCapabilities />*/}
      <AlgorithmsSection />
      <ValidationSection />
      <WizardSteps />

      {/*<AboutAnalysesScreen />*/}
      <Founder />
      <Footer />
    </HomeWrapper>
  );
}
